import hsData from '../data/hsData.json';
import simaData from '../data/sima.json';

interface HSData {
  chapters: { [key: string]: string };
  headings: { [key: string]: string };
  subheadings: { [key: string]: string };
  tariffItems: { 
    [key: string]: {
      description: string;
      mfn: string;
    }
  };
  statisticsLevel: {
    [key: string]: {
      description: string | string[];
      surtax: string;
      agencies: Array<{
        CFIA?: string;
        CNSC?: string;
        DFO?: string;
        ECCC?: string;
        GAC?: string;
        HC?: string;
        PHAC?: string;
        NRCan?: string;
        TC?: string;
      }>;
    };
  };
}


interface SIMAOriginData {
  antiDumping: number | string;
  countervailing: string;
}

interface SIMAData {
  [hsCode: string]: {
    measureInForce: string;
    origins: {
      [country: string]: SIMAOriginData;
    }[];
  };
}

const typedSimaData = simaData as unknown as SIMAData;

const typedHsData = hsData as HSData;

export const hsLookupService = {
  lookup: (code: string) => {
    const cleanCode = code.replace(/\./g, '');
    
    const chapter = cleanCode.slice(0, 2);
    const heading = cleanCode.slice(0, 4);
    const subheading = cleanCode.slice(0, 6);
    const tariffItem = cleanCode.slice(0, 8);
    const statsLevel = cleanCode.slice(0, 10);

    if (!typedHsData.statisticsLevel[statsLevel]) {
      return null;
    }

    const result: any = {
      chapter: { 
        code: chapter,
        description: typedHsData.chapters[chapter] || "Not found"
      },
      heading: {
        code: heading,
        description: typedHsData.headings[heading] || "Not found"
      }
    };

    if (typedHsData.subheadings[subheading]) {
      result.subheading = {
        code: subheading,
        description: typedHsData.subheadings[subheading]
      };
    }

    if (typedHsData.tariffItems[tariffItem]) {
      result.tariffItem = {
        code: tariffItem,
        description: typedHsData.tariffItems[tariffItem].description,
        mfn: typedHsData.tariffItems[tariffItem].mfn
      };
    }
    

    if (typedHsData.statisticsLevel[statsLevel]) {
      const statsData = typedHsData.statisticsLevel[statsLevel];
      result.statisticsLevel = {
        code: statsLevel,
        description: statsData.description,
        surtax: statsData.surtax,
        agencies: statsData.agencies
      };
    }

    // Add SIMA data if it exists
    if (typedSimaData[statsLevel]) {
      result.sima = typedSimaData[statsLevel];
    }

    return result;
  }
};
